import styled from 'styled-components'

export const WidgetsCollectionWrapper = styled.div.attrs((props) => ({
    className: 'col-5 mb-3 ',
}))`
    min-width: 160px;
`
